module.exports = __webpack_public_path__ + "media/Daniel_Birch_-_05_-_Fluid_Dreams.a03a3b96.mp3";